import { lazy } from "react";
import ProtectedRoute from "./ProtectedRoute";
import RequirePermission from "../Components/Common/RequirePermission";

const Dashboard = lazy(() => import("../Pages/Dashboard/Dashboard"));
const AdminUsers = lazy(() => import("../Pages/IAM/AdminUsers"));
const Roles = lazy(() => import("../Pages/IAM/Roles"));
const ProviderUsers = lazy(() => import("../Pages/IAM/user/User"));
const Patients = lazy(() => import("../Pages/Patients/Patients"));
const Payments = lazy(() => import("../Pages/Payments/Payments"));
const Subscriptions = lazy(() => import("../Pages/Subscriptions/Subscriptions"));
const SubscriptionDetail = lazy(() => import("../Pages/Subscriptions/SubscriptionDetail"));
const Website = lazy(() => import("../Pages/Apps/Website/Website"));
const Patient = lazy(() => import("../Pages/Apps/Patient/Patient"));
const Practitioner = lazy(() => import("../Pages/Apps/Practitioner/Practitioner"));
const Studio = lazy(() => import("../Pages/Apps/Studio/Studio"));
const Admin = lazy(() => import("../Pages/Apps/Admin/Admin"));
const Account = lazy(() => import("../Pages/Apps/Account/Account"));
const Trust = lazy(() => import("../Pages/Trust/Trust"));
const Support = lazy(() => import("../Pages/Support/Support"));
const General = lazy(() => import("../Pages/General/General"));
const Partners = lazy(() => import("../Pages/Patners/Patners"));
const UnauthorizedModal = lazy(() => import("../Components/Common/UnauthorizedModal"));
const NotFound = lazy(() => import("../Components/Common/NotFound"));

const guarded = (module, element) => (
  <ProtectedRoute>
    <RequirePermission module={module}>{element}</RequirePermission>
  </ProtectedRoute>
);

const routes = [
  { path: "/dashboard", component: guarded("dashboard", <Dashboard />) },
  { path: "/iam/users", component: guarded("iam_admins", <AdminUsers />) },
  { path: "/iam/roles", component: guarded("iam_roles", <Roles />) },
  { path: "/iam/provider-users", component: guarded("providers", <ProviderUsers />) },
  { path: "/patners", component: guarded("partners", <Partners />) },
  { path: "/patients", component: guarded("patients", <Patients />) },
  { path: "/payments", component: guarded("payment_config", <Payments />) },
  { path: "/subscriptions", component: guarded("subscriptions", <Subscriptions />) },
  { path: "/subscriptions/:tenantId", component: guarded("subscriptions", <SubscriptionDetail />) },
  { path: "/apps/website", component: guarded("apps", <Website />) },
  { path: "/apps/patient", component: guarded("apps", <Patient />) },
  { path: "/apps/practitioner", component: guarded("apps", <Practitioner />) },
  { path: "/apps/studio", component: guarded("apps", <Studio />) },
  { path: "/apps/admin", component: guarded("apps", <Admin />) },
  { path: "/apps/accounts", component: guarded("apps", <Account />) },
  { path: "/trust", component: guarded("trust", <Trust />) },
  { path: "/support", component: guarded("support", <Support />) },
  { path: "/general", component: guarded("general", <General />) },
  { path: "/unauthorized", component: <UnauthorizedModal /> },
  { path: "*", component: <NotFound /> },
];

export default routes;
